import PropTypes from "prop-types";
import React from "react";

const CodingContainer = ({ spaceTopClass, spaceBottomClass, bgClass, img }) => {
  return (
    <div>
      <div
        className={`funfact-area ${spaceTopClass ? spaceTopClass : ""} ${
          spaceBottomClass ? spaceBottomClass : ""
        } ${bgClass ? bgClass : ""}`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7 col-lg-7 order-2 order-lg-2  ">
              <div className="funfact-image">
                <img
                  src={process.env.PUBLIC_URL + img}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-5 col-lg-5 order-1 order-lg-1">
              <div className="funfact-content funfact-res text-center">
                <h2>Robotics</h2>
                <div className="timer">
                  <p>
                    Learning while having fun is critical to Zebra Robotics'
                    success. Robotics for kids is a great way to learn how to
                    program and watch the programs in action. They are not only
                    gaining mechanical and structural skills, but they also
                    learn how to factor in the variables in the environment and
                    guide the robot to complete the tasks programmatically.
                  </p>
                  <div>
                    <p></p>
                  </div>
                </div>
                <div className="funfact-btn funfact-btn--round-shape funfact-btn-red btn-hover">
                  <a href={process.env.PUBLIC_URL + "/locations"}>
                    Choose Location
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
CodingContainer.propTypes = {
  bgClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  img: PropTypes.string,
};

export default CodingContainer;
